const CheckblackSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8046 4.19526C14.0649 4.45561 14.0649 4.87772 13.8046 5.13807L8.08072 10.8619C7.29967 11.643 6.03334 11.643 5.25229 10.8619L2.86177 8.4714C2.60142 8.21106 2.60142 7.78894 2.86177 7.5286C3.12212 7.26825 3.54423 7.26825 3.80458 7.5286L6.1951 9.91912C6.45545 10.1795 6.87756 10.1795 7.13791 9.91912L12.8618 4.19526C13.1221 3.93491 13.5442 3.93491 13.8046 4.19526Z"
      fill="#2A2D31"
    />
  </svg>
);
export default CheckblackSvg;
